import React from 'react';
import { FaSearch } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

interface AdminSearchBarProps {
  searchQuery: string;
  onSearch: (value: string) => void;
  placeholder?: string;
}

const AdminSearchBar: React.FC<AdminSearchBarProps> = ({ searchQuery, onSearch, placeholder }) => {
  const { t } = useTranslation();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    onSearch(value);
  };

  return (
    <div className="relative flex items-center">
      <input
        type="text"
        value={searchQuery}
        onChange={handleChange}
        placeholder={placeholder || t('search')}
        className="p-2 pl-4 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-400 focus:border-brand-400 transition-colors"
      />
      <FaSearch className="absolute right-2 text-brand-400" />
    </div>
  );
};

export default AdminSearchBar;
